<template>
  <div class="app-container">
    <div class="chuKuZuoyeWarp-body">
      <div ref="searchBox">
        <div class="detailsTitle">
          <h4>账单详情</h4>
          <div @click="back"><i class="fa fa-reply"></i></div>
        </div>
        <!-- 查询条件 -->
        <div class="formBox margbot">
          <el-form :inline="true" :model="formInline" class="demo-form-inline" size="mini">
            <div style="">
              <el-form-item>
                <el-button type="primary" size="mini" @click="addYSFn" v-if="btnFlg[0]">添加应收</el-button>
                <el-button type="primary" size="mini" @click="delFn" v-if="btnFlg[1]">删除</el-button>
              </el-form-item>
            </div>
          </el-form>
        </div>
      </div>
      <!--表格1-->
      <div class="chuKuZuoyeWarp-body-table" :style="{height:h}">
        <el-table :data="tableList" ref="tabref" class="tableComent" highlight-current-row @row-click="dianjixuanzhong" border height="100%" size="mini" style="width:100%"
        :header-cell-style="{background:'#F5F5F5',color:'black'}"
        >
          <el-table-column type="selection" width="50" fixed></el-table-column>
          <el-table-column type="index" width="55" label="序号" fixed></el-table-column>
          <el-table-column prop="wayNo" label="运单号"  width="230"></el-table-column>
          <!-- <el-table-column prop="settlementStatus" label="结算方式"  width="120">
          </el-table-column> -->
          <el-table-column prop="" label="结算状态" width="120">
            <template scope="scope">
              <span class="wsStyle" v-show="scope.row.ysSettlementStates == '-1'">未对账</span>
              <span class="wsStyle" v-show="scope.row.ysSettlementStates == '0'">未确认</span>
              <span class="bfStyle" v-show="scope.row.ysSettlementStates == '1'">部分收款</span>
              <span class="ysStyle" v-show="scope.row.ysSettlementStates == '2'">已确认</span>
            </template>
          </el-table-column>
          <el-table-column prop="productTypeName" label="货物类型" width="120">
          </el-table-column>
          <el-table-column prop="liquidatedAmountName" label="结算量" width="120" :formatter="formatterRowEmpty">
          </el-table-column>
          <el-table-column prop="revenueValuationName" label="收入计价" width="120" :formatter="formatterRowEmpty">
            <!-- <template scope="scope">
              0.按吨、1.按车、2.按方、3.按件
              <span v-show="scope.row.revenueValuation == '0'">按吨</span>
              <span v-show="scope.row.revenueValuation == '1'">按车</span>
              <span v-show="scope.row.revenueValuation == '2'">按方</span>
              <span v-show="scope.row.revenueValuation == '3'">按件</span>
            </template> -->
          </el-table-column>
          <el-table-column prop="" label="收入单价" width="130">
            <template scope="scope">
              <div>
                <span v-if="scope.row.revenueValuation == '0'">{{scope.row.incomeUnitPrice}}元/吨</span>
                <span v-if="scope.row.revenueValuation == '1'">
                  <span v-if="scope.row.incomeUnitPrice != 0">{{scope.row.incomeUnitPrice}}元/车</span>
                  <span v-else>-</span>
                </span>
                <span v-if="scope.row.revenueValuation == '2'">{{scope.row.incomeUnitPrice}}元/方</span>
                <span v-if="scope.row.revenueValuation == '3'">{{scope.row.incomeUnitPrice}}元/件</span>
                <span v-if="scope.row.revenueValuation == '' || scope.row.revenueValuation == null">-</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="incomeAmount" label="运费金额(元)" width="140" :formatter="formatterRowEmpty">
          </el-table-column>
          <el-table-column prop="revenueSurcharge" label="收入附加费(元)" width="140" :formatter="formatterRowEmpty">
          </el-table-column>
          <el-table-column prop="grossRevenue" label="收入总额(元)" width="140" :formatter="formatterRowEmpty">
          </el-table-column>
          <el-table-column prop="generalCarrier" label="承运方" width="220" :formatter="formatterRowEmpty">
          </el-table-column>
          <el-table-column prop="plateNumber" label="车牌号" width="130" :formatter="formatterRowEmpty">
          </el-table-column>
          <el-table-column prop="driverName" label="司机姓名" width="130" :formatter="formatterRowEmpty">
          </el-table-column>
          <el-table-column prop="driverPhone" label="司机电话" width="130" :formatter="formatterRowEmpty">
          </el-table-column>
          <el-table-column prop="orderNo" label="订单号" width="240" :formatter="formatterRowEmpty">
          </el-table-column>
          <el-table-column prop="createTime" :formatter="dateTimeFormat" label="创建时间" width="170"></el-table-column>
          <el-table-column prop="actualSigningTime" :formatter="dateTimeFormat" label="签收时间" width="170"></el-table-column>
        </el-table>
      </div>
      <!--分页-->
      <!-- <div class="pags" style="text-align: left;">
        <el-pagination
          background
          @current-change="handleCurrentChangeA"
          :current-page="current"
          :page-size="pagesize"
          :page-sizes="[10, 20, 30, 40,50]"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChangeA"
          :total="total"
        ></el-pagination>
      </div> -->
    </div>
    <!-- 添加应收 -->
    <div>
      <el-dialog :title="YSTitle" :visible.sync="YSAddMark" :close-on-click-modal="false" width="80%" center @close="closeDialog"
      >
        <div class="inpBox" >
          <el-form :inline="true" :model="YSAddFrom" class="demo-form-inline" size="mini" label-width="100px">
            <!-- <el-form-item label="创建时间:">
              <el-date-picker
                v-model="createTimes"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
              ></el-date-picker>
            </el-form-item> -->
            <el-form-item label="签收时间:">
              <el-date-picker
                v-model="actualSignings"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="车牌号:">
              <el-input v-model="YSAddFrom.plateNumber" size="mini" placeholder="请输入车牌号"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="mini" @click="chaxun">查询</el-button>
              <el-button type="primary" size="mini" @click="chongZhi">重置</el-button>
            </el-form-item>
          </el-form>
          <div>
            <el-table :data="listYSData" ref="listYSData" class="elTab" highlight-current-row @row-click="dianjixuanzhong" border size="mini" style="width:100%"
            :header-cell-style="{background:'#F5F5F5',color:'black'}" @selection-change='selectGoods'
            >
              <el-table-column type="selection" width="50" fixed></el-table-column>
              <el-table-column type="index" width="55" label="序号" fixed></el-table-column>
              <el-table-column prop="wayNo" label="运单号" width="230"></el-table-column>
              <el-table-column prop="incomePattern" label="结算方式" width="90">
                <template scope="scope">
                  <span v-show="scope.row.incomePattern == '0'">月结</span>
                  <span v-show="scope.row.incomePattern == '1'">现结</span>
                </template>
              </el-table-column>
              <el-table-column prop="" label="结算状态" align="center" width="100">
                <template scope="scope">
                  <span class="wsStyle" v-show="scope.row.ysSettlementStates == '-1'">未对账</span>
                  <span class="wsStyle" v-show="scope.row.ysSettlementStates == '0'">未确认</span>
                  <span class="ysStyle" v-show="scope.row.ysSettlementStates == '2'">已确认</span>
                </template>
              </el-table-column>
              <el-table-column prop="makeTicketYn" label="是否开票" width="90">
              </el-table-column>
              <el-table-column prop="productTypeName" label="货物类型" width="120">
              </el-table-column>
              <el-table-column prop="liquidatedAmountName" label="结算量" width="120" :formatter="formatterRowEmpty">
              </el-table-column>
              <el-table-column prop="revenueValuationName" label="收入计价" width="100" :formatter="formatterRowEmpty">
                <!-- <template scope="scope">
                  0.按吨、1.按车、2.按方、3.按件
                  <span v-show="scope.row.revenueValuation == '0'">按吨</span>
                  <span v-show="scope.row.revenueValuation == '1'">按车</span>
                  <span v-show="scope.row.revenueValuation == '2'">按方</span>
                  <span v-show="scope.row.revenueValuation == '3'">按件</span>
                </template> -->
              </el-table-column>
              <el-table-column prop="" label="收入单价" width="120">
                <template scope="scope">
                  <div>
                    <span v-if="scope.row.revenueValuation == '0'">{{scope.row.incomeUnitPrice}}元/吨</span>
                    <span v-if="scope.row.revenueValuation == '1'">
                      <span v-if="scope.row.incomeUnitPrice != 0">{{scope.row.incomeUnitPrice}}元/车</span>
                      <span v-else>-</span>
                    </span>
                    <span v-if="scope.row.revenueValuation == '2'">{{scope.row.incomeUnitPrice}}元/方</span>
                    <span v-if="scope.row.revenueValuation == '3'">{{scope.row.incomeUnitPrice}}元/件</span>
                    <span v-if="scope.row.revenueValuation == '' || scope.row.revenueValuation == null">-</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="incomeAmount" label="收入金额(元)" width="130" :formatter="formatterRowEmpty">
              </el-table-column>
              <el-table-column prop="revenueSurcharge" label="收入附加费(元)" width="140" :formatter="formatterRowEmpty">
              </el-table-column>
              <el-table-column prop="grossRevenue" label="收入总额(元)" width="130" :formatter="formatterRowEmpty">
              </el-table-column>
              <el-table-column prop="generalCarrier" label="承运方" width="200" :formatter="formatterRowEmpty">
          </el-table-column>
              <el-table-column prop="plateNumber" label="车牌号" width="120" :formatter="formatterRowEmpty">
              </el-table-column>
              <el-table-column prop="driverName" label="司机姓名" width="120" :formatter="formatterRowEmpty">
              </el-table-column>
              <el-table-column prop="driverPhone" label="司机电话" width="120" :formatter="formatterRowEmpty">
              </el-table-column>
              <el-table-column prop="orderNo" label="订单号" width="240" :formatter="formatterRowEmpty">
              </el-table-column>
              <el-table-column prop="createTime" :formatter="dateTimeFormat" label="创建时间" width="170"></el-table-column>
              <el-table-column prop="actualSigningTime" :formatter="dateTimeFormat" label="签收时间" width="170"></el-table-column>
            </el-table>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="closeDialog">取消</el-button>
          <el-button type="primary" @click="saveFn">确定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import DonMessage from '@/utils/message'
import { getBtn } from '@/utils/getButton'
import { findWayBusinessList, addSettlementBillWayForYs, delSettlementBillWayForYs } from '@/api/newTMS'
import { emptyFn, dateTimeFormat, toFixed, formatterRowEmpty } from '@/utils/util'
export default {
  name: 'Freight',
  components: {
  },
  data () {
    return {
      formatterRowEmpty: formatterRowEmpty,
      toFixed: toFixed,
      dateTimeFormat: dateTimeFormat,
      loading: false,
      YSAddMark: false,
      YSTitle: '添加应收',
      emptyFn: emptyFn,
      h: '500px',
      xuanzhongArr: [],
      // 查询条件
      formInline: {
        timeType: '1'
      },
      pagesize: 20,
      current: 1,
      total: 0,
      // 按钮
      btnFlg: [],
      btnIdArr: ['01N00L0300', '01N00L0400'],
      tableList: [],
      createTimes: [],
      actualSignings: [],
      YSAddFrom: {
        payeeType: '0',
        payee: this.$route.query.payee,
        settlementPattern: this.$route.query.settlementPattern,
        ysSettlementStates: '-1',
        makeTicketYn: this.$route.query.makeTicketYn,
        wayState: '4'
      },
      listYSData: [],
      duiZhangData: {
        wayNumber: 0, // 运单数量
        totalAmount: 0// 选中的应收总额
      },
      ids: []
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/YScalculate')
    this.getList()
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight // 头部搜索盒子高度
    let pH = document.documentElement.clientHeight // 浏览器高度
    this.h = pH - h - 100 + 'px'
    // 218 ->页面除盒子外的高度
  },
  methods: {
    // 获取列表
    getList () {
      this.loading = true
      findWayBusinessList({
        ysSettlementBillId: this.$route.query.ysSettlementBillId
      }).then(res => {
        this.loading = false
        this.tableList = res
        // this.total = res.total
        // this.map = res.map
      })
    },
    dateFormat: function (row, column, cellValue) {
      var t = new Date(cellValue) // row 表示一行数据, transferTime 表示要格式化的字段名称
      var month =
        t.getMonth() + 1 < 10 ? '0' + (t.getMonth() + 1) : t.getMonth() + 1
      var date = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
      var hour = t.getHours() < 10 ? '0' + t.getHours() : t.getHours()
      var minutes = t.getMinutes() < 10 ? '0' + t.getMinutes() : t.getMinutes()
      var seconds = t.getSeconds() < 10 ? '0' + t.getSeconds() : t.getSeconds()
      var str = ''
      if (cellValue == null) {
        str = '-'
      } else {
        str =
          t.getFullYear() +
          '-' +
          month +
          '-' +
          date +
          ' ' +
          hour +
          ':' +
          minutes +
          ':' +
          seconds
      }
      return str
      // return t.getFullYear() + "-" + (t.getMonth() + 1) + "-" + t.getDate(); // 年月日
    },
    // 点击选中需要修改的行
    dianjixuanzhong (row) {
      this.xuanzhongArr = []
      this.xuanzhongArr = row
    },
    // 表格分页
    handleCurrentChangeA (val) {
      this.current = val
      this.getList()
    },
    handleSizeChangeA (val) {
      this.pagesize = val
      this.getList()
    },
    // 点击添加应收
    addYSFn () {
      this.YSAddMark = true
      this.listYSData = []
      this.getYSList()
    },
    getYSList () {
      this.loading = true
      // this.YSAddFrom.createTimeStart = this.createTimes[0]
      // this.YSAddFrom.createTimeEnd = this.createTimes[1]
      this.YSAddFrom.actualSigningTimeStart = this.actualSignings[0]
      this.YSAddFrom.actualSigningTimeEnd = this.actualSignings[1]
      findWayBusinessList(this.YSAddFrom).then(res => {
        this.loading = false
        this.listYSData = res
      })
    },
    // 查询
    chaxun () {
      this.getYSList()
    },
    chongZhi () {
      this.YSAddFrom = {
        payeeType: '0',
        payee: this.$route.query.payee,
        settlementPattern: this.$route.query.settlementPattern,
        ysSettlementStates: '-1',
        makeTicketYn: this.$route.query.makeTicketYn,
        wayState: '4'
      }
      // this.createTimes = []
      this.actualSignings = []
      this.getYSList()
    },
    selectGoods (selection) {
    },
    saveFn () {
      let selectData = this.$refs.listYSData.selection
      if (selectData.length == 0) {
        this.$alert('请选择要操作的数据', '系统提示')
      } else {
        this.ids = []
        this.duiZhangData.totalAmount = 0
        selectData.forEach((item, index) => {
          this.duiZhangData.totalAmount += item.grossRevenue
          this.duiZhangData.wayNumber = index + 1
          this.ids.push(item.id)
        })
        this.duiZhangData.totalAmount = this.toFixed(this.duiZhangData.totalAmount, 2)
        this.$set(this.duiZhangData, 'ids', this.ids.toString())
        this.$set(this.duiZhangData, 'id', this.$route.query.ysSettlementBillId)
        console.log(this.duiZhangData, 'this.duiZhangData')
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        addSettlementBillWayForYs(this.duiZhangData).then(res => {
          loading.close()
          this.$message({
            message: '成功',
            type: 'success'
          })
          this.YSAddMark = false
          this.getList()
        })
          .catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
      }
    },
    // 点击关闭弹窗
    closeDialog () {
      this.YSAddMark = false
      this.YSAddFrom = {
        payeeType: '0',
        payee: this.$route.query.payee,
        settlementPattern: this.$route.query.settlementPattern,
        ysSettlementStates: '-1',
        makeTicketYn: this.$route.query.makeTicketYn,
        wayState: '4'
      }
      // this.createTimes = []
      this.actualSignings = []
    },
    delFn () {
      let selectData = this.$refs.tabref.selection
      if (selectData.length == 0) {
        this.$alert('请选择要操作的数据', '系统提示')
      } else {
        this.ids = []
        this.duiZhangData.totalAmount = 0
        selectData.forEach((item, index) => {
          this.duiZhangData.totalAmount += item.grossRevenue
          this.duiZhangData.wayNumber = index + 1
          this.ids.push(item.id)
        })
        this.duiZhangData.totalAmount = this.toFixed(this.duiZhangData.totalAmount, 2)
        this.$set(this.duiZhangData, 'ids', this.ids.toString())
        this.$set(this.duiZhangData, 'id', this.$route.query.ysSettlementBillId)
        console.log(this.duiZhangData, 'this.duiZhangData')
        this.$confirm('是否删除？', '提示', {
          confirmButtonText: '是',
          cancelButtonText: '否',
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          delSettlementBillWayForYs(this.duiZhangData).then(res => {
            loading.close()
            this.$message({
              message: '成功',
              type: 'success'
            })
            this.getList()
          })
            .catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
        }).catch(() => { })
      }
    },
    back () {
      // this.$router.go(-1)// 返回上一层
      this.$router.push({ name: 'YScalculate', query: { ZDFlag: true } })
    }
  }
}
</script>
<style lang="scss" scoped>
/deep/.el-range-editor--mini.el-input__inner {
  height: 28px;
  width: 315px !important;
}
/deep/.inpBox .el-input--mini .el-input__inner{
  width: 150px !important;
}
.el-form-item {
  margin-left: 10px;
}
</style>
